<!--
 * @Author: wjc
 * @Date: 2025-06-18 09:09:53
 * @LastEditors: wjc
 * @LastEditTime: 2025-09-25 17:14:07
 * @Description: 
-->
<template>
  <TooltipRoot v-bind="forwarded">
    <slot></slot>
  </TooltipRoot>
</template>

<script setup lang="ts">
  import type { TooltipRootEmits, TooltipRootProps } from 'reka-ui'

  import { TooltipRoot, useForwardPropsEmits } from 'reka-ui'

  const props = defineProps<TooltipRootProps>()
  const emits = defineEmits<TooltipRootEmits>()

  const forwarded = useForwardPropsEmits(props, emits)
</script>
